/**
 * Default javascript
 *
 *
 *
 * @project UithoornsMooiste
 * @version 1.0
 * @author Wim Jurriaans
 * @copyright 2017
 * @license MIT
 *
 * @date 22-11-2019
 *
 *
 */

'use strict';

import blazy from 'blazy';

let sitePath,
  menuTriggerMobile,
  mainMenuItems,
  pageWidth,
  bLazy,
  nix =
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

window.requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

const pageInit = (e) => {
  if (
    location.host == 'localhost' ||
    location.host == 'localhost:3000' ||
    location.host == 'localhost:8888' ||
    location.host == '192.168.0.85'
  ) {
    sitePath = location.protocol + '//localhost/UithoornsMooiste_2019/dist/';
  } else {
    sitePath = location.protocol + '//' + location.host + '/';
  }

  bLazy = new blazy({});

  mainMenuItems = document
    .querySelector('.menu__main-navigation')
    .querySelectorAll('nav > ol:first-child > li');

  menuTriggerMobile = document.querySelector('#menu-main-hamburger');

  menuTriggerMobile.addEventListener(
    'click',
    (evt) => {
      let target = evt.currentTarget;
      target.classList.toggle('js-menu-main-hamburger-open');
      target.nextSibling.nextSibling.classList.toggle(
        'menu__main-navigation--open'
      );
    },
    false
  );

  [].forEach.call(document.querySelectorAll('.has-submenu'), (i) =>
    i.addEventListener('click', openSubMobileMenu(e, i), false)
  );

  pageWidth = getPageWidth();

  window.addEventListener(
    'resize',
    function () {
      bLazy.revalidate();
      pageWidth = getPageWidth();
      if (pageWidth > 768) cleanUpMobileMenu();
    },
    false
  );

  if (document.getElementById('submit')) {
    checkForm();
  }

  if (document.getElementsByClassName('photo-album')) {
    var t = document.getElementsByClassName('photo-album'),
      n = t.length;
    for (var i = 0; i < n; i++) {
      t[i].addEventListener('click', showLightBox(t[i]), false);
    }
  }
};

const openSubMobileMenu = (e, elm) => {
  return function () {
    if (checkBurger()) {
      e.preventDefault();
      e.stopPropagation();
      [].forEach.call(
        mainMenuItems,
        (i) => {
          if (i !== elm) i.classList.toggle('js-menu-item-hide');
          else i.classList.toggle('js-menu-item-back');
        },
        false
      );
      elm.querySelector('ol').classList.toggle('js-menu-subitems-show');
    }
  };
};

const checkBurger = () =>
  document
    .getElementById('menu-main-hamburger')
    .classList.contains('js-menu-main-hamburger-open');

const cleanUpMobileMenu = () => {
  [].forEach.call(mainMenuItems, (i) => {
    i.classList.remove('js-menu-item-hide');
    i.classList.remove('js-menu-item-back');
    if (i.querySelector('ol') != null)
      i.querySelector('ol').classList.remove('js-menu-subitems-show');
  });
};

const getPageWidth = () => {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
};

const preLoadImg = (url, callback) => {
  let _img = new Image();
  _img.src = url;
  if (typeof callback === 'function') _img.onload = callback;
};

const scrollToY = (scrollTarget, scrollSpeed, scrollEasing) => {
  let scrollY = window.scrollY,
    scrollTargetY = scrollTarget || 0,
    speed = scrollSpeed || 2000,
    easing = scrollEasing || 'easeOutSine',
    currentTime = 0;

  let time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  );

  let PI_D2 = Math.PI / 2,
    easingEquations = {
      easeOutSine: function (pos) {
        return Math.sin(pos * (Math.PI / 2));
      },
      easeInOutSine: function (pos) {
        return -0.5 * (Math.cos(Math.PI * pos) - 1);
      },
      easeInOutQuint: function (pos) {
        if ((pos /= 0.5) < 1) {
          return 0.5 * Math.pow(pos, 5);
        }
        return 0.5 * (Math.pow(pos - 2, 5) + 2);
      },
    };

  const tick = () => {
    currentTime += 1 / 60;
    var p = currentTime / time;
    var t = easingEquations[easing](p);
    if (p < 1) {
      requestAnimFrame(tick);
      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  };

  tick();
};

const calculateMaxHeight = (element) => {
  let _width = element.offsetWidth,
    _height = 0;

  element.style.position = 'absolute';
  element.style.left = '-2000px';
  element.style.maxHeight = '5000px';
  element.style.width = _width + 'px';
  _height = element.scrollHeight;
  element.style.position = '';
  element.style.left = '';
  element.style.width = '';
  element.style.maxHeight = '';
  return _height;
};

/*-------------------------------------------------------------------- LIGHTBOX */
var imgList = [],
  totalNrOfFotos = 0,
  preImg,
  descriptions,
  currentLightBoxIndex = 0,
  popUpMargin = 100,
  _popW = 1024,
  _popH = 600 + popUpMargin,
  blind = document.getElementById('blind'),
  lightBox = document.getElementById('popup'),
  lightBoxFoto = document.getElementById('lightboxfoto');

function showLightBox(t) {
  return function () {
    imgList = [];
    descriptions = [];
    totalNrOfFotos = 0;
    currentLightBoxIndex = 0;
    blind.classList.add('page-blind-show');
    lightBox.classList.add('popup-window-open');
    imgList = t.getAttribute('data-images').split(',');
    descriptions = t.getAttribute('data-descriptions').split(',');
    totalNrOfFotos = imgList.length;
    document.getElementsByClassName('popup-window-title')[0].innerHTML =
      t.getAttribute('data-title');
    setFootNote(currentLightBoxIndex, totalNrOfFotos);
    document
      .getElementsByClassName('popup-window-close')[0]
      .addEventListener('click', closePopUpLightBox, false);
    document
      .getElementsByClassName('popup-window-nav-previous')[0]
      .addEventListener('click', navHandler, false);
    document
      .getElementsByClassName('popup-window-nav-next')[0]
      .addEventListener('click', navHandler, false);
    blind.addEventListener('click', closePopUpLightBox, false);
    disableScroll();
    window.addEventListener('resize', placeAndSizeLightBox, false);
    loadImgLightBox(currentLightBoxIndex);
  };
}

function closePopUpLightBox() {
  currentLightBoxIndex = 0;
  totalNrOfFotos = 0;
  imgList = [];
  descriptions = [];
  lightBoxFoto.src = nix;
  blind.classList.remove('page-blind-show');
  lightBox.classList.remove('popup-window-open');
  lightBox.removeAttribute('style');
  document
    .getElementsByClassName('popup-window-close')[0]
    .removeEventListener('click', closePopUpLightBox, false);
  blind.removeEventListener('click', closePopUpLightBox, false);
  document
    .getElementsByClassName('popup-window-nav-previous')[0]
    .removeEventListener('click', navHandler, false);
  document
    .getElementsByClassName('popup-window-nav-next')[0]
    .removeEventListener('click', navHandler, false);
  window.removeEventListener('resize', placeAndSizeLightBox, false);
  enableScroll();
}

function loadImgLightBox(index) {
  preImg = new Image();
  preload('show');
  preImg.onload = function () {
    placeAndSizeLightBox();
    lightBoxFoto.src = sitePath + 'assets/images/img/' + imgList[index];
    preload('hide');
  };
  preImg.src = sitePath + 'assets/images/img/' + imgList[index];
}

function placeAndSizeLightBox() {
  var _w = getViewport()[0],
    _h = getViewport()[1],
    _ratio = _popW / _popH,
    _wRatio = _w / _h;

  if (_w - 50 <= _popW + 50 && _wRatio < 1) {
    lightBox.style.width = '90%';
  }

  if (_wRatio >= 1) {
    lightBox.style.width = (_h - 80) * _ratio + 'px';
  }
}

function setFootNote(index, total) {
  document.getElementsByClassName('popup-window-footnote')[0].innerHTML =
    unescape(decodeURI(descriptions[index])) +
    '&nbsp;&nbsp;(foto ' +
    (index + 1) +
    ' van ' +
    total +
    ')';
}

function navHandler(event, d) {
  if (event.target.classList.contains('popup-window-nav-previous')) d = -1;
  else d = 1;
  currentLightBoxIndex += d;
  if (currentLightBoxIndex < 0) currentLightBoxIndex = totalNrOfFotos - 1;
  else if (currentLightBoxIndex > totalNrOfFotos - 1) currentLightBoxIndex = 0;
  setFootNote(currentLightBoxIndex, totalNrOfFotos);
  loadImgLightBox(currentLightBoxIndex);
}

function preload(status) {
  var preloader = document.getElementById('popup-preloader');
  status == 'show'
    ? (preloader.style.display = 'block')
    : (preloader.style.display = 'none');
}

function getViewport() {
  var viewPortWidth;
  var viewPortHeight;
  // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
  if (typeof window.innerWidth != 'undefined') {
    (viewPortWidth = window.innerWidth), (viewPortHeight = window.innerHeight);
  }
  // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
  else if (
    typeof document.documentElement != 'undefined' &&
    typeof document.documentElement.clientWidth != 'undefined' &&
    document.documentElement.clientWidth != 0
  ) {
    (viewPortWidth = document.documentElement.clientWidth),
      (viewPortHeight = document.documentElement.clientHeight);
  }
  // older versions of IE
  else {
    (viewPortWidth = document.getElementsByTagName('body')[0].clientWidth),
      (viewPortHeight = document.getElementsByTagName('body')[0].clientHeight);
  }
  return [viewPortWidth, viewPortHeight];
}

function stopDefault(event) {
  if (event.preventDefault) event.preventDefault();
  if (event.stopPropagation) event.stopPropagation();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    stopDefault(e);
    return false;
  }
}

function disableScroll() {
  if (window.addEventListener)
    window.addEventListener('DOMMouseScroll', stopDefault, false);
  window.onwheel = stopDefault;
  window.onmousewheel = document.onmousewheel = stopDefault;
  window.ontouchmove = stopDefault;
  document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {
  if (window.removeEventListener)
    window.removeEventListener('DOMMouseScroll', stopDefault, false);
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;
}

/* ------------------------------------------------- FORM HANDELING */

/* ------------------------------------------------- FORM HANDELING */

var isFilled = function (val) {
  var regex = /^\s*$/;
  var test = !regex.test(val);
  return test;
};

var isEmail = function (val) {
  var regex =
    /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
  var test = regex.test(val);
  return test;
};

var isPhone = function (val) {
  var regex =
    /^(\+|00|0)(31\s?)?(6[\s-]?[1-9][0-9]{7}|[1-9][0-9][\s-]?[1-9][0-9]{6}|[1-9][0-9]{2}[\s-]?[1-9][0-9]{5})/;
  var test = regex.test(val);
  return test;
};

var isZip = function (val) {
  var regex = /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/;
  var test = regex.test(val);
  return test;
};

var notNul = function (val) {
  return parseInt(val) > 0 || val != '';
};

var forEachShow = function (a, s) {
  var l = a.length;
  for (var i = 0; i < l; i++) a[i].style.display = s;
};

var showFormError = function (obj) {
  var err = document.createElement('div');
  var txt = document.createTextNode(
    obj.getAttribute('data-validation-message')
  );
  err.appendChild(txt);
  err.className = 'form-error';
  obj.parentNode.parentNode.appendChild(err);
};

var hideFormError = function (obj) {
  var element =
    obj.parentNode.parentNode.getElementsByClassName('form-error')[0];
  obj.parentNode.parentNode.removeChild(element);
};

var checkForm = function () {
  var submitBtn = document.getElementById('submit');
  var formName = submitBtn.getAttribute('data-formname');
  submitBtn.addEventListener(
    'click',
    function () {
      handleForm(formName);
    },
    false
  );
};

var handleForm = function (formEl) {
  var theForm = document.getElementById(formEl);
  var formElements = theForm.elements;
  var nrOfFormElements = formElements.length;
  var isValid = true;
  for (var i = 0; i < nrOfFormElements; i++) {
    var obj = formElements[i];

    if (obj.parentNode.parentNode.getElementsByClassName('form-error')[0])
      hideFormError(obj);

    var validationType = obj.getAttribute('data-validation');

    if (obj.parentNode.getElementsByClassName('form-error')[0]) {
      obj.parentNode.removeChild(
        obj.parentNode.getElementsByClassName('form-error')[0]
      );
      isValid = true;
    }
    if (validationType != null && obj.parentNode.style.display !== 'none') {
      var getRules = /validate\[(.*)\]/.exec(validationType);
      getRules.shift(0);
      switch (getRules[0]) {
        case 'required':
          if (obj.type == 'text' && !isFilled(obj.value)) {
            showFormError(obj);
            isValid = false;
          }
          if (obj.type == 'checkbox' && !obj.checked) {
            showFormError(obj);
            isValid = false;
          }
          if (obj.tagName == 'SELECT' && obj.value == 'null') {
            showFormError(obj);
            isValid = false;
          }
          if (obj.tagName == 'TEXTAREA' && !isFilled(obj.value)) {
            showFormError(obj);
            isValid = false;
          }
          break;
        case 'email':
          if (!isEmail(obj.value)) {
            showFormError(obj);
            isValid = false;
          }
          break;
        case 'phone':
          if (!isPhone(obj.value)) {
            showFormError(obj);
            isValid = false;
          }
          break;
        case 'zipcode':
          if (!isZip(obj.value)) {
            showFormError(obj);
            isValid = false;
          }
          break;
        case 'notnul':
          if (!notNul(obj.value)) {
            showFormError(obj);
            isValid = false;
          }
          break;
      }
    }
  }
  if (isValid) {
    theForm.submit();
  } else {
    var pos =
      parseInt(document.getElementById(formEl).offsetTop) +
      parseInt(
        getComputedStyle(document.getElementById('main'))
          .getPropertyValue('margin-top')
          .split('px')[0]
      ) -
      100;
    scrollToY(pos, 10, 'easeInOutQuint');
  }

  for (var i = 0; i < nrOfFormElements; i++) {
    formElements[i].addEventListener(
      'focus',
      function (e) {
        if (
          e.target.parentNode.parentNode.getElementsByClassName('form-error')[0]
        )
          hideFormError(e.target);
      },
      false
    );
  }
};

//BINDING EVENTS
if (document.addEventListener)
  document.addEventListener('DOMContentLoaded', pageInit, false);

window.addEventListener(
  'resize',
  () => {
    bLazy.revalidate();
  },
  false
);



// WEBPACK FOOTER //
// ./src/js/src/default.js